import { Stack, Typography, useTheme } from "@mui/material";

const DolphinBanner = ({ newTheme }) => {
  const theme = useTheme();
  return (
    <Stack flexDirection={{ xs: "column", sm: "row" }} justifyContent={"center"} gap={5} alignItems={"center"}>
      <Stack
        sx={{
          width: { xs: "90%", sm: "50%" },
          height: { xs: "auto", sm: "auto" },
        }}
      >
        <img src="/static/images/AVC_Dolphin.jpg" alt="dolphin" />
      </Stack>
      <Stack
        flexDirection={"row"}
        sx={{
          width: { xs: "100%", sm: "50%" },
        }}
        px={3}
      >
        <Typography variant="subtitle1">
          <span style={{ color: newTheme.text.color.primary }}>سامانه دلفین</span>
          <span style={{ color: theme.palette.grey.gm }}>
            &nbsp;(سامانه زنجیره ارزش آبزیان) بستری است نوآورانه، برای مدیریت و کنترل کیفیت هر یک از حلقه‌های زنجیره
            ارزش آبزیان ایران، از مراحل تأمین، پرورش، تولید و فرآوری تا نگهداری، حمل‌ونقل، توزیع و رسیدن محصول به دست
            مصرف‌کننده نهایی.
          </span>
        </Typography>
      </Stack>
    </Stack>
  );
};
export default DolphinBanner;
